/** Keep only items that are not soft-deleted. Safe for null/undefined arrays. */
export function filterActive<T>(
  items: T[] | null | undefined
): T[] {
  if (!items?.length) {
    return [];
  }
  return items.filter((item) => !(item as { is_deleted?: boolean | null })?.is_deleted);
}
